import { useFormBuilderWithConsent } from '@gov-nx/core/service';

export const useForm = (isDisabled: boolean, isLowAuthorization: boolean) =>
	useFormBuilderWithConsent<Record<never, never>, unknown>([], {
		isDisabled,
		isLowAuthorization,
	});
